// extracted by mini-css-extract-plugin
export default {"wrapper":"VanityPhrase-module__wrapper","phraseInputField":"VanityPhrase-module__phraseInputField"};